module.exports = __webpack_public_path__ + "static/media/madhucon4.5e2aeea3.png";